/**
 * Close control for FireCMS full-screen entity view (double-arrow).
 * FireCMS only puts an X on the side panel; full-screen drops barActions.
 */
import React from "react";
import { useNavigate } from "react-router";
import {
  useNavigationController,
  type FireCMSPlugin,
  type PluginFormActionProps,
} from "@firecms/core";
import { CloseIcon, IconButton, Tooltip } from "@firecms/ui";
import { fullscreenCloseUrl } from "../lib/fullscreenCloseUrl";

function FullscreenCloseAction(props: PluginFormActionProps) {
  const navigate = useNavigate();
  const navigation = useNavigationController();
  if (props.openEntityMode !== "full_screen") return null;
  const collectionPath = props.collection.id ?? props.collection.path ?? props.path;
  return (
    <Tooltip title="Close">
      <IconButton
        className="self-center order-first"
        size="smallest"
        aria-label="Close destination"
        onClick={() => {
          navigate(fullscreenCloseUrl(navigation.buildUrlCollectionPath, collectionPath));
        }}
      >
        <CloseIcon size="smallest" />
      </IconButton>
    </Tooltip>
  );
}

export const fullscreenClosePlugin: FireCMSPlugin = {
  key: "venttra-fullscreen-close",
  form: {
    ActionsTop: FullscreenCloseAction,
  },
};
